module.exports = __webpack_public_path__ + "img/title.2412d5a9.png";